import { render, staticRenderFns } from "./PaymentRevenueRule.vue?vue&type=template&id=90080476&"
import script from "./PaymentRevenueRule.vue?vue&type=script&lang=js&"
export * from "./PaymentRevenueRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports